import { render } from "./InfoBar.vue?vue&type=template&id=6125344f&scoped=true"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"

import "./InfoBar.vue?vue&type=style&index=0&id=6125344f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6125344f"]])

export default __exports__